<template>
  <v-card class="pa-10">
    <div class="_fs-36">
      {{ title }}
    </div>

    <div>{{ subtitle }}</div>

    <v-divider
      v-if="title || subtitle"
      class="my-4">
    </v-divider>

    <slot></slot>
  </v-card>
</template>

<script>
export default {
  name: 'BaseCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
}
</script>
